// 新高考生涯测评
const Shengyaceping = () => import('../views/ceping/shengyaceping/shengyaceping.vue');
//主页面
const EvluaClassify = () => import('../views/ceping/shengyaceping/view/evlua/classify.vue');
const EvluaClassify12 = () => import('../views/ceping/shengyaceping/view/evlua/classify12');
const EvluaClassify13 = () => import('../views/ceping/shengyaceping/view/evlua/classify13');
const EvluaClassify14 = () => import('../views/ceping/shengyaceping/view/evlua/classify14');
const EvluaClassify22 = () => import('../views/ceping/shengyaceping/view/evlua/classify22');
const EvluaClassify23 = () => import('../views/ceping/shengyaceping/view/evlua/classify23');
// 认知潜能
const RzqnIndex = () => import('../views/ceping/shengyaceping/view/rzqn/index.vue');
const RzqnQuesOne = () => import('../views/ceping/shengyaceping/view/rzqn/ques1');
const RzqnQues21 = () => import('../views/ceping/shengyaceping/view/rzqn/ques21');
const RzqnQues22 = () => import('../views/ceping/shengyaceping/view/rzqn/ques22');
const RzqnQues3 = () => import('../views/ceping/shengyaceping/view/rzqn/ques3');
const RzqnQues4 = () => import('../views/ceping/shengyaceping/view/rzqn/ques4');
const RzqnQues5 = () => import('../views/ceping/shengyaceping/view/rzqn/ques5');
const RzqnQues6 = () => import('../views/ceping/shengyaceping/view/rzqn/ques6');
const RzqnQues71 = () => import('../views/ceping/shengyaceping/view/rzqn/ques71');
const RzqnQues72 = () => import('../views/ceping/shengyaceping/view/rzqn/ques72');
const RzqnQues8 = () => import('../views/ceping/shengyaceping/view/rzqn/ques8');
const RzqnQues91 = () => import('../views/ceping/shengyaceping/view/rzqn/ques91');
const RzqnQues92 = () => import('../views/ceping/shengyaceping/view/rzqn/ques92');
const RzqnQues10 = () => import('../views/ceping/shengyaceping/view/rzqn/ques10');
const RzqnQues11 = () => import('../views/ceping/shengyaceping/view/rzqn/ques11');
const RzqnQues121 = () => import('../views/ceping/shengyaceping/view/rzqn/ques121')
const RzqnQues122 = () => import('../views/ceping/shengyaceping/view/rzqn/ques122')
const RzqnQues123 = () => import('../views/ceping/shengyaceping/view/rzqn/ques123')
const RzqnQues13 = () => import('../views/ceping/shengyaceping/view/rzqn/ques13')
const RzqnInstru1 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru1')
const RzqnInstru21 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru21')
const RzqnInstru3 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru3')
const RzqnInstru4 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru4')
const RzqnInstru5 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru5')
const RzqnInstru6 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru6')
const RzqnInstru7 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru7')
const RzqnInstru8 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru8')
const RzqnInstru9 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru9')
const RzqnInstru10 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru10')
const RzqnInstru11 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru11')
const RzqnInstru12 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru12')
const RzqnInstru13 = () => import('../views/ceping/shengyaceping/view/rzqn/quesInstru13')
const RzqnGuide1 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide1')
const RzqnGuide21 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide21')
const RzqnGuide22 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide22')
const RzqnGuide3 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide3')
const RzqnPlay3 = () => import('../views/ceping/shengyaceping/view/rzqn/quesPlay3')
const RzqnGuide4 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide4')
const RzqnGuide5 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide5')
const RzqnGuide6 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide6')
const RzqnGuide71 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide71')
const RzqnGuide72 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide72')
const RzqnPlay7 = () => import('../views/ceping/shengyaceping/view/rzqn/quesPlay7')
const RzqnGuide8 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide8')
const RzqnGuide91 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide91')
const RzqnGuide92 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide92')
const RzqnGuide10 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide10')
const RzqnGuide11 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide11')
const RzqnGuide121 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide121')
const RzqnGuide122 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide122')
const RzqnGuide123 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide123')
const RzqnGuide13 = () => import('../views/ceping/shengyaceping/view/rzqn/quesGuide13')
const RzqnSuccess1 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess1')
const RzqnSuccess21 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess21')
const RzqnSuccess22 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess22')
const RzqnSuccess3 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess3')
const RzqnSuccess4 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess4')
const RzqnSuccess5 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess5')
const RzqnSuccess6 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess6')
const RzqnSuccess71 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess71')
const RzqnSuccess72 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess72')
const RzqnSuccess8 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess8')
const RzqnSuccess91 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess91')
const RzqnSuccess92 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess92')
const RzqnSuccess10 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess10')
const RzqnSuccess11 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess11')
const RzqnSuccess121 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess121')
const RzqnSuccess122 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess122')
const RzqnSuccess123 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess123')
const RzqnSuccess13 = () => import('../views/ceping/shengyaceping/view/rzqn/quesSuccess13')
//性格特性
const XgtxIndex = () => import('../views/ceping/shengyaceping/view/xgtx')
const quesOne = () => import('../views/ceping/shengyaceping/view/xgtx/quesOne')
const quesGuide1 = () => import('../views/ceping/shengyaceping/view/xgtx/quesGuide1')
const quesGuide2 = () => import('../views/ceping/shengyaceping/view/xgtx/quesGuide2')
const quesSuccess1 = () => import('../views/ceping/shengyaceping/view/xgtx/quesSuccess1')
const quesSuccess2 = () => import('../views/ceping/shengyaceping/view/xgtx/quesSuccess2')
const quesTwo = () => import('../views/ceping/shengyaceping/view/xgtx/quesTwo')
//心理健康
const XljkIndex = () => import('../views/ceping/shengyaceping/view/xljk')
const XljkGuide = () => import('../views/ceping/shengyaceping/view/xljk/quesGuide')
const xljkQuesOne = () => import('../views/ceping/shengyaceping/view/xljk/quesOne')
const xljkQuesSuccess = () => import('../views/ceping/shengyaceping/view/xljk/quesSuccess')
//兴趣倾向
const XqqxIndex = () => import('../views/ceping/shengyaceping/view/xqqx')
const XkcjIndex = () => import('../views/ceping/shengyaceping/view/xqqx/index2')
const XqqxQuesOne = () => import('../views/ceping/shengyaceping/view/xqqx/ques1')
const XqqxQuesTwo = () => import('../views/ceping/shengyaceping/view/xqqx/ques2')
const XqqxQuesThree = () => import('../views/ceping/shengyaceping/view/xqqx/ques3')
const XqqxQuesFour = () => import('../views/ceping/shengyaceping/view/xqqx/ques4')
const XqqxGuide1 = () => import('../views/ceping/shengyaceping/view/xqqx/quesGuide1')
const XqqxGuide2 = () => import('../views/ceping/shengyaceping/view/xqqx/quesGuide2')
const XqqxGuide3 = () => import('../views/ceping/shengyaceping/view/xqqx/quesGuide3')
const XqqxGuide4 = () => import('../views/ceping/shengyaceping/view/xqqx/quesGuide4')
const XqqxSuccess1 = () => import('../views/ceping/shengyaceping/view/xqqx/quesSuccess1')
const XqqxSuccess2 = () => import('../views/ceping/shengyaceping/view/xqqx/quesSuccess2')
const XqqxSuccess3 = () => import('../views/ceping/shengyaceping/view/xqqx/quesSuccess3')
const XqqxSuccess4 = () => import('../views/ceping/shengyaceping/view/xqqx/quesSuccess4')
export default[
    {
        path: '/shengyaceping',
        component: Shengyaceping,
        meta:{requireAuth:true,roles:['student']},
        children:[
            {
                path: '/',
                name: 'EvluaClassify',
                component:EvluaClassify,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/evlua/classify/12',
                name: 'EvluaClassify12',
                component: EvluaClassify12,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/evlua/classify/13',
                name: 'EvluaClassify13',
                component: EvluaClassify13,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/evlua/classify/14',
                name: 'EvluaClassify14',
                component: EvluaClassify14,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/evlua/classify/22',
                name: 'EvluaClassify22',
                component: EvluaClassify22,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/evlua/classify/23',
                name: 'EvluaClassify23',
                component: EvluaClassify23,
                meta:{requireAuth:true,roles:['student']},
            },
            // 认知潜能
            {
                path: '/shengyaceping/rzqn',//认知潜能主页
                name: 'RZQN',
                component: RzqnIndex,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/1',//信息加工能力
                name: 'RzqnQuesOne',
                component: RzqnQuesOne,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/21',//工作记忆能力
                name: 'RzqnQues21',
                component: RzqnQues21,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/22',
                name: 'RzqnQues22',
                component: RzqnQues22,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/3',//空间能力
                name: 'RzqnQues3',
                component: RzqnQues3,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/4',//表象能力
                name: 'RzqnQues4',
                component: RzqnQues4,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/5',//思维转换
                name: 'RzqnQues5',
                component: RzqnQues5,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/6',//逻辑推理
                name: 'RzqnQues6',
                component: RzqnQues6,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/7',//动手操作能力
                name: 'RzqnQues71',
                component: RzqnQues71,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/72',
                name: 'RzqnQues72',
                component: RzqnQues72,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/8',//语言能力
                name: 'RzqnQues8',
                component: RzqnQues8,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/91',//数学能力
                name: 'RzqnQues91',
                component: RzqnQues91,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/92',
                name: 'RzqnQues92',
                component: RzqnQues92,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/10',//组织管理能力
                name: 'RzqnQues10',
                component: RzqnQues10,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/11',//人际交往能力
                name: 'RzqnQues11',
                component: RzqnQues11,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/121',//美术能力
                name: 'RzqnQues121',
                component: RzqnQues121,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/122',
                name: 'RzqnQues122',
                component: RzqnQues122,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/123',
                name: 'RzqnQues123',
                component: RzqnQues123,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/13',//隐藏图形测试
                name: 'RzqnQues13',
                component: RzqnQues13,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/1',
                name: 'RzqnInstru1',
                component: RzqnInstru1,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/2',
                name: 'RzqnInstru21',
                component: RzqnInstru21,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/3',
                name: 'RzqnInstru3',
                component: RzqnInstru3,
                meta:{requireAuth:true,roles:['student']},
            },

            {
                path: '/shengyaceping/rzqn/instru/4',
                name: 'RzqnInstru4',
                component: RzqnInstru4,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/5',
                name: 'RzqnInstru5',
                component: RzqnInstru5,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/6',
                name: 'RzqnInstru6',
                component: RzqnInstru6,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/7',
                name: 'RzqnInstru7',
                component: RzqnInstru7,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/8',
                name: 'RzqnInstru8',
                component: RzqnInstru8,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/9',
                name: 'RzqnInstru9',
                component: RzqnInstru9,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/10',
                name: 'RzqnInstru10',
                component: RzqnInstru10,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/11',
                name: 'RzqnInstru11',
                component: RzqnInstru11,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/12',
                name: 'RzqnInstru12',
                component: RzqnInstru12,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/instru/13',
                name: 'RzqnInstru13',
                component: RzqnInstru13,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/1',
                name: 'RzqnGuide1',
                component: RzqnGuide1,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/21',
                name: 'RzqnGuide21',
                component: RzqnGuide21,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/22',
                name: 'RzqnGuide22',
                component: RzqnGuide22,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/3',
                name: 'RzqnGuide3',
                component: RzqnGuide3,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/play/3',
                name: 'RzqnPlay3',
                component: RzqnPlay3,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/4',
                name: 'RzqnGuide4',
                component: RzqnGuide4,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/5',
                name: 'RzqnGuide5',
                component: RzqnGuide5,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/6',
                name: 'RzqnGuide6',
                component: RzqnGuide6,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/7',
                name: 'RzqnGuide71',
                component: RzqnGuide71,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/play/7',
                name: 'RzqnPlay7',
                component: RzqnPlay7,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/72',
                name: 'RzqnGuide72',
                component: RzqnGuide72,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/8',
                name: 'RzqnGuide8',
                component: RzqnGuide8,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/91',
                name: 'RzqnGuide91',
                component: RzqnGuide91,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/92',
                name: 'RzqnGuide92',
                component: RzqnGuide92,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/10',
                name: 'RzqnGuide10',
                component: RzqnGuide10,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/11',
                name: 'RzqnGuide11',
                component: RzqnGuide11,
                meta:{requireAuth:true,roles:['student']},
            },

            {
                path: '/shengyaceping/rzqn/guide/121',
                name: 'RzqnGuide121',
                component: RzqnGuide121,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/122',
                name: 'RzqnGuide122',
                component: RzqnGuide122,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/123',
                name: 'RzqnGuide123',
                component: RzqnGuide123,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/guide/13',
                name: 'RzqnGuide13',
                component: RzqnGuide13,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/1',
                name: 'RzqnSuccess1',
                component: RzqnSuccess1,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/21',
                name: 'RzqnSuccess21',
                component: RzqnSuccess21,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/22',
                name: 'RzqnSuccess22',
                component: RzqnSuccess22,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/3',
                name: 'RzqnSuccess3',
                component: RzqnSuccess3,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/4',
                name: 'RzqnSuccess4',
                component: RzqnSuccess4,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/5',
                name: 'RzqnSuccess5',
                component: RzqnSuccess5,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/6',
                name: 'RzqnSuccess6',
                component: RzqnSuccess6,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/7',
                name: 'RzqnSuccess71',
                component: RzqnSuccess71,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/72',
                name: 'RzqnSuccess72',
                component: RzqnSuccess72,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/8',
                name: 'RzqnSuccess8',
                component: RzqnSuccess8,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/91',
                name: 'RzqnSuccess91',
                component: RzqnSuccess91,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/92',
                name: 'RzqnSuccess92',
                component: RzqnSuccess92,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/10',
                name: 'RzqnSuccess10',
                component: RzqnSuccess10,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/11',
                name: 'RzqnSuccess11',
                component: RzqnSuccess11,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/121',
                name: 'RzqnSuccess121',
                component: RzqnSuccess121,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/122',
                name: 'RzqnSuccess122',
                component: RzqnSuccess122,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/123',
                name: 'RzqnSuccess123',
                component: RzqnSuccess123,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/rzqn/success/13',
                name: 'RzqnSuccess13',
                component: RzqnSuccess13,
                meta:{requireAuth:true,roles:['student']},
            },
            //人格特性测评
            {
                path: '/shengyaceping/xgtx', //人格特性
                name: 'XgtxIndex',
                component: XgtxIndex,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xgtx/guide/1',//
                name: 'quesGuide1',
                component: quesGuide1,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xgtx/guide/2',
                name: 'quesGuide2',
                component: quesGuide2,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xgtx/1',//人格特性第一步
                name: 'quesOne',
                component: quesOne,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xgtx/2',//人格特性第一步
                name: 'quesTwo',
                component: quesTwo,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xgtx/success/1',
                name: 'quesSuccess1',
                component: quesSuccess1,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xgtx/success/2',
                name: 'quesSuccess2',
                component: quesSuccess2,
                meta:{requireAuth:true,roles:['student']},
            },
            // 心理健康
            {
                path: '/shengyaceping/xljk',   // 心理健康
                name: 'XLJK',   
                component: XljkIndex,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xljk/guide',
                name: 'XljkGuide',
                component: XljkGuide,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xljk/1',
                name: 'quesOne1',
                component: xljkQuesOne,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xljk/success',
                name: 'xljkQuesSuccess',
                component: xljkQuesSuccess,
                meta:{requireAuth:true,roles:['student']},
            },
            // 兴趣倾向
            {
                path: '/shengyaceping/xqqx',   // 兴趣倾向
                name: 'XQQX',
                component: XqqxIndex,
                meta:{requireAuth:true,roles:['student']},
            },
            // 学科成绩
            {
                path: '/shengyaceping/xkcj', // 学习态度问卷
                name: 'XKCJ',
                component: XkcjIndex,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/1',// 兴趣倾向问卷
                name: 'XqqxQuesOne',
                component: XqqxQuesOne,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/2',// 学习态度问卷
                name: 'XqqxQuesTwo',
                component: XqqxQuesTwo,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/3',
                name: 'XqqxQuesThree',
                component: XqqxQuesThree,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/4',
                name: 'XqqxQuesFour',
                component: XqqxQuesFour,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/guide/1',
                name: 'XqqxGuide1',
                component: XqqxGuide1,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/guide/2',
                name: 'XqqxGuide2',
                component: XqqxGuide2,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/guide/3',
                name: 'XqqxGuide3',
                component: XqqxGuide3,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/guide/4',
                name: 'XqqxGuide4',
                component: XqqxGuide4,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/success/4',
                name: 'XqqxSuccess4',
                component: XqqxSuccess4,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/success/1',
                name: 'XqqxSuccess1',
                component: XqqxSuccess1,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/success/2',
                name: 'XqqxSuccess2',
                component: XqqxSuccess2,
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/shengyaceping/xqqx/success/3',
                name: 'XqqxSuccess3',
                component: XqqxSuccess3,
                meta:{requireAuth:true,roles:['student']},
            }
        ]
    }
]
